module.exports = __webpack_public_path__ + "img/aej1n-66wvl.034.57229720.png";